import { render } from "./InsuranceModal.vue?vue&type=template&id=72eecd0a&scoped=true"
import script from "./InsuranceModal.vue?vue&type=script&lang=js"
export * from "./InsuranceModal.vue?vue&type=script&lang=js"

import "./InsuranceModal.vue?vue&type=style&index=0&id=72eecd0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72eecd0a"]])

export default __exports__